// import _ from "lodash"
import rulesHandler from '@/services/rulesHandler'

import filter from 'lodash/filter';
import forEachLodash from 'lodash/forEach';
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';
import has from 'lodash/has';
import groupBy from 'lodash/groupBy';

async function refactorDetail(data, rules, producer, onlyManager, source) {

    var eventObj = data.events;
    var sportObj = data.events.sport;
    var categoryObj = data.events.category;
    var tournamentObj = data.events.tournament;
    var marketObj = data.settings;
    var sourceObj = data.events.source;
    var periods = (data.periods) ? data.periods : []

    var tree_structure = {
        sport: sportObj.id,
        category: categoryObj.id,
        tournament: tournamentObj.id
    }
    tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)

    var sport_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(sportObj, rules, onlyManager, sportObj.id);
        resolve(result)
    });

    var category_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.id);
        resolve(result)
    });

    var tournament_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.id);
        resolve(result)
    });

    var event_promise = new Promise(async (resolve, reject) => {
        let result = await refactorEventDetailOdds(eventObj, rules, onlyManager, tree_structure, producer, periods);
        resolve(result)
    });

    var markets_group_promise = new Promise(async (resolve, reject) => {
        let result = await refactorGroupMarkets(marketObj, rules.lang);
        resolve(result)
    });

    const responsePromises = await Promise.all([
        sport_promise,
        category_promise,
        tournament_promise,
        event_promise,
        markets_group_promise
    ])


    return {
        sport: {
            ...responsePromises[0]
        },
        category: {
            ...responsePromises[1]
        },
        tournament: {
            ...responsePromises[2]
        },
        event: {
            ...responsePromises[3].events[0]
        },
        event_sources: {
            ...responsePromises[3].events_sources[0]
        },
        groupMarkets: {
            ...responsePromises[4]
        },
        source: source,
        sourceStatscore: sourceObj[0].value
    }

}

async function refactorOddsDetail(data, rules, producer, onlyManager, source) {

    var eventObj = data.events;
    var sportObj = data.tournament[0].sport_detail;
    var categoryObj = data.tournament[0].category_detail;
    var tournamentObj = data.tournament[0];

    var tree_structure = {
        sport: sportObj.source,
        category: categoryObj.source,
        tournament: tournamentObj.source
    }

    tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)

    var event_promise = new Promise(async (resolve, reject) => {
        let result = await refactorEventDetailOdds(eventObj, rules, onlyManager, tree_structure, producer);
        resolve(result)
    });

    const responsePromises = await Promise.all([
        event_promise,
    ])

    return {
        event: {
            ...responsePromises[0].events[0]
        }
    }

}

// async function refactorLive(data, rules, producer, onlyManager, source) {
//
//     var eventsCollections = data.events;
//
//     var first = _.first(data.events);
//     var sportObj
//     var categoryObj
//     var tournamentObj
//
//     if (hasIn(first, 'resource')) {
//         var filterSportFirst = find(first.resource, {type: "sport"})
//
//         var idS1
//         if (filterSportFirst) {
//             sportObj = filterSportFirst.data
//             idS1 = _.split(sportObj.source, ':');
//             _.assign(sportObj,{id:idS1[2]})
//         } else {
//             var idT = _.split(first.sport, ':');
//             sportObj = {
//                 "id": idT[2],
//                 "source": first.sport,
//                 "detail": [{
//                     "lang": "en",
//                     "text": first.sport
//                 }]
//             }
//         }
//         var idC1
//         var filterCategoryFirst = find(first.resource, {type: "category"})
//         if (filterCategoryFirst) {
//             categoryObj = filterCategoryFirst.data
//             idC1 = _.split(categoryObj.source, ':');
//             _.assign(categoryObj,{id:idC1[2]})
//         } else {
//             var id = _.split(first.category, ':');
//             categoryObj = {
//                 "id": id[2],
//                 "source": first.category,
//                 "detail": [{
//                     "lang": "en",
//                     "text": first.category
//                 }]
//             }
//         }
//
//         var idT1
//         var filterTournamentFirst = find(first.resource, {type: "tournament"})
//         if (filterTournamentFirst) {
//             tournamentObj = filterTournamentFirst.data
//             idT1 = _.split(tournamentObj.source, ':');
//             _.assign(tournamentObj,{id:idT1[2]})
//         } else {
//             var id = _.split(first.tournament, ':');
//             tournamentObj = {
//                 "id": id[2],
//                 "source": first.tournament,
//                 "detail": [{
//                     "lang": "en",
//                     "text": first.tournament
//                 }]
//             }
//         }
//
//     } else {
//         var idS = _.split(first.sport, ':');
//         sportObj = {
//             "id": idS[2],
//             "source": first.sport,
//             "detail": [{
//                 "lang": "en",
//                 "text": first.sport
//             }]
//         }
//         var idC = _.split(first.category, ':');
//         categoryObj = {
//             "id": idC[2],
//             "source": first.category,
//             "detail": [{
//                 "lang": "en",
//                 "text": first.category
//             }]
//         }
//         var idT = _.split(first.tournament, ':');
//         tournamentObj = {
//             "id": idT[2],
//             "source": first.tournament,
//             "detail": [{
//                 "lang": "en",
//                 "text": first.tournament
//             }]
//         }
//     }
//
//     //var sportObj = data.tournament[0].sport_detail;
//
//     //var sportObj = data.tournament[0].sport_detail;
//     //var categoryObj = data.tournament[0].category_detail;
//     //var tournamentObj = data.tournament[0];
//     //var tournamentObj = {
//     //     "source": "sr:tournament:2949",
//     //     "detail": [ {
//     //         "lang": "en",
//     //         "text": this.source
//     //     } ]
//
//     // };
//     var marketObj = data.settings;
//
//     var tree_structure = {
//         sport: sportObj.source,
//         category: categoryObj.source,
//         tournament: tournamentObj.source
//     }
//
//     tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)
//
//     var sport_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorElement(sportObj, rules, onlyManager, sportObj.source);
//         resolve(result)
//     });
//
//     var category_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.source);
//         resolve(result)
//     });
//
//     var tournament_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.source);
//         resolve(result)
//     });
//
//     var events_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorEventsOdds(eventsCollections, rules, onlyManager, tree_structure, producer);
//         resolve(result)
//     });
//
//     var markets_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorMarkets(marketObj, rules.lang);
//         resolve(result)
//     });
//
//
//     const responsePromises = await Promise.all([sport_promise, category_promise, tournament_promise, events_promise, markets_promise])
//
//     return {
//         sport: {
//             ...responsePromises[0]
//         },
//         category: {
//             ...responsePromises[1]
//         },
//         tournament: {
//             ...responsePromises[2]
//         },
//         events: {
//             ...responsePromises[3].events
//         },
//         events_sources: [
//             ...responsePromises[3].events_sources
//         ],
//         markets: {
//             ...responsePromises[4]
//         },
//         markets_count:
//         Object.keys(responsePromises[4]).length
//         ,
//         message: {
//             num_events: eventsCollections.length
//         },
//         source: source,
//         type: 'prematch'
//     }
//
// }

async function refactorLive(dataAll, rules, producer, onlyManager, group = true) {

    return new Promise(async (resolve, reject) => {
        try {

            var data = find(dataAll, {'selected': true})

            // eliminare i disabled

            var eventsObj = data.events
            var marketsObj = data.settings

            var promise = []

            forEachLodash(eventsObj, async (event) =>{
                promise.push(this.refactorSingleLive(event, rules, producer, onlyManager, marketsObj))
            })

            var refactored = []
            await Promise.all(promise).then((result) =>{
                var clean_events = filter(result, function(o) { return o.category.status != false && o.tournament.status != false && o != false });

                if(clean_events.length == 0){
                    resolve(clean_events)
                }

                if(group){

                    var groupedByTournament = groupBy(clean_events, (obj) =>{
                        return obj.tournament.id
                    })

                    forEachLodash(groupedByTournament, (tourn, index) =>{
                        var events = []
                        var events_sources = []

                        forEachLodash(tourn, (event) =>{
                            events.push(event.events[0])
                            events_sources.push(event.events_sources[0])
                        })

                        var events_ordered = orderBy(events, ['time'], ['asc'])

                        let object = {
                            category : tourn[0].category,
                            markets : tourn[0].markets,
                            markets_count : tourn[0].markets_count,
                            sport : tourn[0].sport,
                            tournament : tourn[0].tournament,
                            type: tourn[0].type,
                            events: events_ordered,
                            events_sources: events_sources,
                            events_count: events_sources.length,
                            categoryOrder : tourn[0].categoryOrder != null ? tourn[0].categoryOrder : 9999,
                            tournamentOrder: tourn[0].tournamentOrder != null ? tourn[0].tournamentOrder :   9999
                        }

                        refactored.push(object)
                    })
                    resolve(refactored)

                }else{

                    resolve(clean_events)

                }
            })

        } catch (e) {
            console.log(e)
        }
    })

}


async function refactorSingleLive(event, rules, producer, onlyManager, marketsObj){

    return new Promise(async (resolve, reject) => {

        try {

            var sportObj = event.sport;
            var categoryObj = event.category;
            var tournamentObj = event.tournament;
            var eventsCollections = [event]

            var tree_structure = {
                sport: sportObj.id,
                category: categoryObj.id,
                tournament: tournamentObj.id
            }

            tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)

            var sport_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(sportObj, rules, onlyManager, sportObj.id);
                resolve(result)
            });

            var category_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.id);
                resolve(result)
            });

            var tournament_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.id);
                resolve(result)
            });

            var events_promise = new Promise(async (resolve, reject) => {
                let result = await refactorEventsOdds(eventsCollections, rules, onlyManager, tree_structure, producer);
                resolve(result)
            });

            var markets_promise = new Promise(async (resolve, reject) => {
                let result = await refactorMarkets(marketsObj, rules.lang);
                resolve(result)
            });

            const responsePromises = await Promise.all([
                sport_promise,
                category_promise,
                tournament_promise,
                events_promise,
                markets_promise
            ])

            let result = {
                sport: {
                    ...responsePromises[0]
                },
                category: {
                    ...responsePromises[1]
                },
                tournament: {
                    ...responsePromises[2]
                },
                events: {
                    ...responsePromises[3].events
                },
                events_sources: [
                    ...responsePromises[3].events_sources
                ],
                markets: {
                    ...responsePromises[4]
                },
                markets_count: Object.keys(responsePromises[4]).length,
                type: 'live',
                categoryOrder: event.categoryOrder || 9999,
                tournamentOrder: event.tournamentOrder || 9999
            }
            resolve(result)

        }catch (e) {

            console.log(e)
            resolve(false)
        }


    });
}

async function refactorSingleNextEvent(event, rules, producer, onlyManager, marketsObj){

    return new Promise(async (resolve, reject) => {

        try {


            var sportObj = event.sport;
            var categoryObj = event.category;
            var tournamentObj = event.tournament;
            var eventsCollections = [event]

            var tree_structure = {
                sport: sportObj.id,
                category: categoryObj.id,
                tournament: tournamentObj.id
            }

            tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)

            var sport_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(sportObj, rules, onlyManager, sportObj.id);
                resolve(result)
            });



            var category_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.id);
                resolve(result)
            });

            var tournament_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.id);
                resolve(result)
            });

            var events_promise = new Promise(async (resolve, reject) => {
                let result = await refactorEventsOdds(eventsCollections, rules, onlyManager, tree_structure, producer);
                resolve(result)
            });

            var markets_promise = new Promise(async (resolve, reject) => {
                let result = await refactorMarkets(marketsObj, rules.lang);
                resolve(result)
            });

            const responsePromises = await Promise.all([
                sport_promise,
                category_promise,
                tournament_promise,
                events_promise,
                markets_promise
            ])

            let result = {
                sport: {
                    ...responsePromises[0]
                },
                category: {
                    ...responsePromises[1]
                },
                tournament: {
                    ...responsePromises[2]
                },
                events: {
                    ...responsePromises[3].events
                },
                events_sources: [
                    ...responsePromises[3].events_sources
                ],
                markets: {
                    ...responsePromises[4]
                },
                markets_count: Object.keys(responsePromises[4]).length,
                type: 'prematch'
            }

            resolve(result)

        }catch (e) {

            console.log(e)
            resolve(false)
        }


    });
}
async function refactorSingleNextEventV2(event,sport, category, tournament, producer, onlyManager, marketsObj){

    try {


        //todo MOCK category e tournament


        let categoryObj = {
            id: event.categoryId, name: event.categoryName
        }
        let tournamentObj = {
            id: event.tournamentId, name: event.tournamentName
        }



        let result = {
            category: {
                ...categoryObj
            },
            tournament: {
                ...tournamentObj
            },
            ...event,
            type: 'prematch'
        }

        return result

    }catch (e) {

        console.log(e)
        return false
    }
}

async function refactorSingleEventDay(event, rules, producer, onlyManager, marketsObj, headerSign = null){

    return new Promise(async (resolve, reject) => {

        try {


            var sportObj = event.sport;
            var categoryObj = event.category;
            var tournamentObj = event.tournament;
            var eventsCollections = [event]


            var tree_structure = {
                sport: sportObj.id,
                category: categoryObj.id,
                tournament: tournamentObj.id
            }
            // console.log("tree_structure",tree_structure)
            tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)

            var sport_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(sportObj, rules, onlyManager, sportObj.id);
                resolve(result)
            });

            var category_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.id);
                resolve(result)
            });

            var tournament_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.id);
                resolve(result)
            });

            var events_promise = new Promise(async (resolve, reject) => {
                let result = await refactorEventsOdds(eventsCollections, rules, onlyManager, tree_structure, producer);
                resolve(result)
            });

            var markets_promise = new Promise(async (resolve, reject) => {
                let result = await refactorMarkets(marketsObj, rules.lang);
                resolve(result)
            });

            const responsePromises = await Promise.all([

                sport_promise,
                category_promise,
                tournament_promise,
                events_promise,
                markets_promise
            ])

            let result = {
                sport: {
                    ...responsePromises[0]
                },
                category: {
                    ...responsePromises[1]
                },
                tournament: {
                    ...responsePromises[2]
                },
                events: {
                    ...responsePromises[3].events
                },
                events_sources: [
                    ...responsePromises[3].events_sources
                ],
                markets: {
                    ...responsePromises[4]
                },
                markets_count: Object.keys(responsePromises[4]).length,
                type: 'prematch',
                headerSign: headerSign
            }

            resolve(result)

        }catch (e) {
            //debugger

            console.log(e)
            resolve(false)
        }


    });
}

async function refactorSingleEventsBestPlayed(event, rules, producer, onlyManager, marketsObj, headerSign = null){

    return new Promise(async (resolve, reject) => {

        try {

            var sportObj = event.sport;
            var categoryObj = event.category;
            var tournamentObj = event.tournament;
            var eventsCollections = [event]

            var tree_structure = {
                sport: sportObj.id,
                category: categoryObj.id,
                tournament: tournamentObj.id
            }

            tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)

            var sport_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(sportObj, rules, onlyManager, sportObj.id);
                resolve(result)
            });

            var category_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.id);
                resolve(result)
            });

            var tournament_promise = new Promise(async (resolve, reject) => {
                let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.id);
                resolve(result)
            });

            var events_promise = new Promise(async (resolve, reject) => {
                let result = await refactorEventsOdds(eventsCollections, rules, onlyManager, tree_structure, producer);
                resolve(result)
            });

            var markets_promise = new Promise(async (resolve, reject) => {
                let result = await refactorMarkets(marketsObj, rules.lang);
                resolve(result)
            });

            const responsePromises = await Promise.all([
                sport_promise,
                category_promise,
                tournament_promise,
                events_promise,
                markets_promise
            ])

            let result = {
                sport: {
                    ...responsePromises[0]
                },
                category: {
                    ...responsePromises[1]
                },
                tournament: {
                    ...responsePromises[2]
                },
                events: {
                    ...responsePromises[3].events
                },
                events_sources: [
                    ...responsePromises[3].events_sources
                ],
                markets: {
                    ...responsePromises[4]
                },
                markets_count: Object.keys(responsePromises[4]).length,
                type: 'prematch',
                headerSign: headerSign
            }

            resolve(result)

        }catch (e) {

            console.log(e)
            resolve(false)
        }


    });
}
async function refactorSingleEventsBestPlayedV2(event, headerSign = null){

    try {


        var categoryObj = {
            categoryId: event.categoryId,
            categoryName: event.categoryName
        };
        var tournamentObj = {
            tournamentId: event.tournamentId,
            tournamentName: event.tournamentName
        }


        let result = {
            category: {
                ...categoryObj
            },
            tournament: {
                ...tournamentObj
            },
            ...event,
            // events_sources: [
            //     ...responsePromises[3].events_sources
            // ],
            // markets: {
            //     ...responsePromises[4]
            // },
            // markets_count: Object.keys(responsePromises[4]).length,
            type: 'prematch',
            headerSign: headerSign
        }

        return result

    }catch (e) {

        console.log(e)
        return false
    }
}

async function refactorPreview(data, rules, producer, onlyManager, source) {

    var eventsCollections = data.events;
    var sportObj = data.tournament[0].sport_detail;
    var categoryObj = data.tournament[0].category_detail;
    var tournamentObj = data.tournament[0];
    var marketObj = data.settings;
    let market_header = data.market_header != null ? data.market_header : null; //todo check if needed
    let market_subheader = data.market_subheader != null ? data.market_subheader : null; //todo check if needed
    let headerSign = data.headerSign != null ? data.headerSign : null;

    var tree_structure = {
        sport: sportObj.id,
        category: categoryObj.id,
        tournament: tournamentObj.id
    }

    tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)

    var sport_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(sportObj, rules, onlyManager, sportObj.id);
        resolve(result)
    });

    var category_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.id);
        resolve(result)
    });

    var tournament_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.id);
        resolve(result)
    });

    var events_promise = new Promise(async (resolve, reject) => {
        let result = await refactorEventsOdds(eventsCollections, rules, onlyManager, tree_structure, producer);
        resolve(result)
    });

    var markets_promise = new Promise(async (resolve, reject) => {
        let result = await refactorMarkets(marketObj, rules.lang);
        resolve(result)
    });


    const responsePromises = await Promise.all([sport_promise, category_promise, tournament_promise, events_promise, markets_promise])



    return {
        sport: {
            ...responsePromises[0]
        },
        category: {
            ...responsePromises[1]
        },
        tournament: {
            ...responsePromises[2]
        },
        events: {
            ...responsePromises[3].events
        },
        events_sources: [
            ...responsePromises[3].events_sources
        ],
        markets: {
            ...responsePromises[4]
        },
        markets_count:
        Object.keys(responsePromises[4]).length,
        message: {
            num_events: eventsCollections.length
        },
        source: source,
        type: 'prematch',
        market_header: market_header, //todo check if needed
        market_subheader: market_subheader, //todo check if needed
        headerSign: headerSign
    }

}
async function refactorPreviewV2(data,sport, category, tournament, producer, onlyManager, source) {


    let headerSign = data.headerSign != null ? data.headerSign : null;

    return {
        sport: {
            ...sport
        },
        category: {
            ...category
        },
        tournament: {
            ...tournament
        },
        events: {
            ...data.events
        },
        source: source,
        type: 'prematch',
        headerSign: headerSign
    }

}


export const refactorEventsBestPlayedV3 = (apiResult) => {
    if (!apiResult || !apiResult.events) return [];

    const events = apiResult.events;
    const headerSign = apiResult.headerSign || [];

    // 1. Raggruppa gli eventi per data (YYYY-MM-DD)
    // La vista si aspetta: { "2026-02-14": { events: [...] }, ... }
    const eventsByDate = events.reduce((acc, event) => {
        // Estraiamo la data senza l'orario
        const dateKey = event.scheduled.split('T')[0];

        if (!acc[dateKey]) {
            acc[dateKey] = { events: [] };
        }
        acc[dateKey].events.push(event);
        return acc;
    }, {});

    // 2. Creiamo un "finto" oggetto Torneo/Categoria per ingannare la vista
    // e fargli renderizzare la card come se fosse un torneo unico "Best Played"
    const bestPlayedObject = {
        tournament: {
            id: 'best_played_virtual',
            name: 'Eventi Più Giocati'
        },
        category: {
            id: 'best_cat',
            name: 'Highlights'
        },
        sport: {
            id: apiResult.sportId || events[0]?.sportId || '6046',
            name: apiResult.sportName || events[0]?.sportName || 'Football'
        },
        type: 'bestplayed', // Tipo custom per gestire logiche specifiche se servono
        events: eventsByDate,
        headerSign: headerSign,
        source: 'bestplayed_api'
    };

    // Ritorniamo un array perché il v-for della vista cicla su un array di oggetti (di solito tornei)
    return [bestPlayedObject];
};
//
// async function refactorLivePreviewV3(data,headerSign, sportsAvailable) {
//
//
//     return {
//
//         events: {
//             ...data
//         },
//         type: 'live',
//         headerSign: headerSign,
//         sportsAvailable: sportsAvailable
//     }
//
// }


/**
 * REFACTOR LIVE (V3) - GENERICO
 * Usa headerSign per capire quali quote mancano e crearle dinamicamente (Lucchetti).
 */
 async function refactorLivePreviewV3 (data, headerSign, sportsAvailable) {

    // Clona i dati per sicurezza
    let groupedEvents = _.cloneDeep(data);

    // --- FUNZIONE GENERICA: RIEMPIE I BUCHI USANDO HEADER SIGN ---
    const enrichMarketWithHeaderSign = (market) => {
        if (!headerSign || !Array.isArray(headerSign)) return;

        // 1. Trova la definizione del mercato in headerSign (es. cerca marketId 59)
        // Nota: Usiamo String() per sicurezza sui confronti
        const definition = headerSign.find(h => String(h.marketId) === String(market.marketId || market.id));

        // Se non c'è definizione o non ha nomi di esiti, non possiamo fare nulla
        if (!definition || !definition.outcomeNames || definition.outcomeNames.length === 0) return;

        // Assicuriamoci che l'array outcome esista
        if (!market.outcome) market.outcome = [];

        // 2. Itera sugli esiti PREVISTI (es. "1", "2", "No Goal")
        definition.outcomeNames.forEach((expectedName, index) => {
            const normalize = s => String(s || '').trim().toLowerCase();

            // Cerca se l'esito esiste già tra quelli arrivati
            const exists = market.outcome.find(o =>
                normalize(o.name || o.outcomeName) === normalize(expectedName)
            );

            if (!exists) {
                // 3. SE MANCA, CREALO COME LUCCHETTO
                // Generico per qualsiasi mercato, non solo il 59
                market.outcome.push({
                    unique_id: `fe_gen_${market.unique_id || market.marketId}_${index}`,
                    id: `fe_gen_${market.unique_id || market.marketId}_${index}`,
                    name: expectedName,
                    outcomeName: expectedName,
                    outcome_odd_value: 0,
                    odds: 0,
                    active: false, // UI mostra Lucchetto
                    status: '2',   // Locked
                    type_change: 'equal'
                });
            }
        });

        // 4. ORDINA in base all'ordine definito in headerSign
        market.outcome.sort((a, b) => {
            const idxA = definition.outcomeNames.indexOf(a.name || a.outcomeName);
            const idxB = definition.outcomeNames.indexOf(b.name || b.outcomeName);

            // Gestione sicurezza se i nomi non matchano
            if (idxA === -1) return 1;
            if (idxB === -1) return -1;

            return idxA - idxB;
        });
    };


    // --- PROCESSO EVENTI ---
    const processLiveEvent = (event) => {
        // 1. Mapping Mercati (Backend "markets" -> Frontend "odds")
        // La tua UI cicla su event.odds
        if (!event.odds && event.markets) event.odds = event.markets;

        if (event.odds && Array.isArray(event.odds)) {
            event.odds.forEach(market => {

                // 2. Mapping Quote (Backend "odds" -> Frontend "outcome")
                if (market.odds && Array.isArray(market.odds)) {

                    market.outcome = market.odds.filter(odd => {
                        // Logica base: se è attiva e > 0 passa.
                        const isActive = (odd.active === true && parseFloat(odd.odds) > 0);

                        // Se il backend manda già lucchetti (status 2), li lasciamo passare
                        const isLocked = (String(odd.status) === "2" || odd.is_fake_locked === true);

                        if (isLocked) {
                            odd.active = false;
                            odd.outcome_odd_value = 0;
                            return true;
                        }

                        return isActive;

                    }).map(odd => {
                        // Normalizzazione dati
                        odd.outcome_odd_value = parseFloat(odd.odds);
                        odd.unique_id = odd.unique_id || odd.outcomeId || odd.id;
                        if (!odd.name && odd.outcomeName) odd.name = odd.outcomeName;
                        return odd;
                    });

                    // 3. 🔥 APPLICA LA LOGICA GENERICA DI RIEMPIMENTO 🔥
                    // Passiamo il mercato e l'headerSign globale
                    enrichMarketWithHeaderSign(market);
                }
            });
        }
    };

    // --- ITERAZIONE GRUPPI/EVENTI ---
    if (groupedEvents) {
        _.forEach(groupedEvents, (group) => {
            let eventsList = Array.isArray(group) ? group : (group.events || []);

            if (Array.isArray(eventsList)) {
                eventsList.forEach(event => processLiveEvent(event));
            } else if (group.id && (group.markets || group.odds)) {
                processLiveEvent(group);
            }
        });
    }

    return {
        events: groupedEvents,
        type: 'live',
        headerSign: headerSign,
        sportsAvailable: sportsAvailable
    };
}


async function refactorPreviewAntepost(data, rules, producer, onlyManager, source) {


    var eventDetail = data.events[0];
    var sportObj = data.events[0].sport;
    var categoryObj = data.events[0].category;
    var tournamentObj = data.events[0].tournament;
    var fixtureExtraData = data.events[0].FixtureExtraData;

    var tree_structure = {
        sport: sportObj.id,
        category: categoryObj.id,
        tournament: tournamentObj.id
    }

    tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)

    var sport_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(sportObj, rules, onlyManager, sportObj.id);
        resolve(result)
    });

    var category_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.id);
        resolve(result)
    });

    var tournament_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.id);
        resolve(result)
    });

    // var event_desc_promise = new Promise(async (resolve, reject) => {
    //     let result = await refactorElement(eventDetail, rules, onlyManager, eventDetail.id);
    //     resolve(result)
    // });

    // var event_parent_promise = new Promise(async (resolve, reject) => {
    //     if (eventDetail.parent != undefined) {
    //         let result = await refactorElement(eventDetail.parent, rules, onlyManager, eventDetail.parent.source);
    //         resolve(result)
    //     } else {
    //         resolve(null)
    //     }
    //
    // });

    var events_promise = new Promise(async (resolve, reject) => {
        let result = await refactorEventsAntepostOdds(eventDetail, rules, onlyManager, tree_structure, producer);
        resolve(result)
    });

    // var markets_promise = new Promise(async (resolve, reject) => {
    //     let result = await refactorMarkets(marketObj, rules.lang);
    //     resolve(result)
    // });


    const responsePromises = await Promise.all([sport_promise, category_promise, tournament_promise, events_promise])
    //
    // if (!hybridSports.includes(sportObj.source)) {
    //     responsePromises[0].name = 'Antepost ' + responsePromises[0].name
    // }

    var tournamentObj = {
        ...responsePromises[2]
    }

    if(fixtureExtraData){
        var raceTitle = find(fixtureExtraData, {'Name':'RaceTitle'})
        if(raceTitle){
            tournamentObj.name += ' - '+raceTitle.Value
        }

        var raceNumber = find(fixtureExtraData, {'Name':'RaceNumber'})
        if(raceNumber && !raceTitle.Value.toString().includes(raceNumber.Value.toString())){
            tournamentObj.name += ' - n°'+raceNumber.Value
        }

    }

    return {
        sport: {
            ...responsePromises[0]
        },
        category: {
            ...responsePromises[1]
        },
        tournament: {
            ...tournamentObj
        },
        // desc: {
        //     ...responsePromises[3]
        // },
        event: {
            ...responsePromises[3].events
        },
        events_sources: [
            ...responsePromises[3].events_sources
        ],
        // markets: {
        //     ...responsePromises[5]
        // },
        // parent: {
        //     ...responsePromises[6]
        // },
        message: {
            num_events: 1
        },
        source: source,
        type: 'antepost'
    }

}

async function refactorElement(element, rules, onlyManager, source) {

    var element_with_rules = await rulesHandler.applyRules(element, rules.manager, source)
    if (!onlyManager) {
        element_with_rules = await rulesHandler.applyRules(element_with_rules, rules.skin, source)
    }
    //console.log("element_with_rules",element_with_rules)
    var desc = await rulesHandler.getDesc(element_with_rules, rules.lang)

    return {
        id: element.id,
        _id: (element._id) ? element._id : false,
        source: source,
        name: desc,
        order: (element_with_rules.order != undefined) ? element_with_rules.order : 9999,
        status: (element_with_rules.status_rule != undefined) ? element_with_rules.status_rule : true
    }
}

async function refactorEventsAntepostOdds(event, rules, onlyManager, treeStructure, producer) {


    var result_odds = [];
    var eventsPreviewSources = [event.id];

    if (event.odds) {

        var result_odds_fetch = await rulesHandler.applyRulesToOdds(event.odds, event.id, event.type, treeStructure, rules, onlyManager, producer,'antepost','detail')
        result_odds = await orderBy(result_odds_fetch.oddsArray, ['specifier_id'], ['asc'])

    } else {

        result_odds = {
            id_market: null,
            void: true
        }

    }

    return {
        events: {
            id: event.id,
            source: event.id,
            competitors: {},
            odds: {...result_odds},
            count_odds: result_odds_fetch.count_odds,
            type: event.type,
            time: new Date(event.scheduled).getTime(),
        },
        events_sources: eventsPreviewSources
    }

}

async function refactorEventsOdds(eventsCollections, rules, onlyManager, treeStructure, producer) {

    let events = []
    let eventsPreviewSources = []

    const options = {year: 'numeric', month: 'long', day: 'numeric'};

    await Promise.all(eventsCollections.map(async (event) => {

            var status = true
            const rules_disabled = {
                manager: filter(rules.manager, {'type': 'disable', 'scope': 'event', 'source': event.id.toString()}),
                skin: filter(rules.skin, {'type': 'disable', 'scope': 'event', 'source': event.id.toString()})
            }

            if (rules_disabled.manager.length > 0 || rules_disabled.skin.length > 0) {
                status = await getStatusEventFromRule(event.id.toString(), rules_disabled)
            }

            if (event != null && event.count > 0 && status) {

                eventsPreviewSources.push(event.id)

                var competitors = {}
                var result_odds = {};
                var description = ''

                switch (event.type) {
                    case "match":

                        competitors = {
                            home: {
                                ...await refactorElement(event.competitors[0], rules, onlyManager, event.competitors[0].id)
                            },
                            away: {
                                ...await refactorElement(event.competitors[1], rules, onlyManager, event.competitors[1].id)
                            },
                        }

                        description = competitors.home.name + ' - ' + competitors.away.name

                        if (event.odds) {

                            var typeOdd = event.type

                            if(typeOdd != 'antepost'){

                                switch (event.sport_event_status._attributes.status) {
                                    case 1:{
                                        typeOdd = 'prematch'
                                        break
                                    }
                                    case 9:{
                                        typeOdd = 'prematch'
                                        break
                                    }
                                    case 2:{
                                        typeOdd = 'live'
                                        break
                                    } default:{
                                        typeOdd = 'prematch'
                                        break
                                    }
                                }

                            }

                            result_odds = await rulesHandler.applyRulesToOdds(event.odds, event.id, event.type, treeStructure, rules, onlyManager,producer, typeOdd)

                        } else {

                            result_odds = {
                                id_market: null,
                                void: true
                            }

                        }
                        break;

                    case "stage":
                    case "season":
                    case "simple:tournament":

                        // var desc_parent = find(event.parent, {'lang': lang});
                        // if (!desc_parent) {
                        //     desc_parent = find(event.parent, {'lang': 'en'});
                        // }
                        //
                        // var desc_event = find(event.detail, {'lang': lang});
                        // if (!desc_event) {
                        //     desc_event = find(event.detail, {'lang': 'en'});
                        // }
                        //
                        // let d_parent = (desc_parent) ? desc_parent.text : 'Parent Detail non presente';
                        // let d_event = (desc_event) ? desc_event.text : 'Event Detail non presente';
                        //
                        // description = d_parent + ' - ' + d_event;
                        //
                        // oddsArray = {
                        //     id_market: null,
                        //     void: true
                        // }

                        break;
                }

                var single_event = {
                    id: event.id,
                    scheduled: event.scheduled,
                    day: new Date(event.scheduled).toLocaleDateString(rules.lang, options),
                    time: new Date(event.scheduled).getTime(),
                    status: (has(event, 'sport_event_status')) ? event.sport_event_status._attributes.status : 0,
                    competitors: competitors,
                    odds: {...result_odds.oddsArray},
                    type: event.type,
                    description: description,
                    count_odds: event.count - result_odds.count_odds,
                    livescore: event.livescore,
                    quickbet: event.quickbet,
                    evidence: (event.evidence !== undefined) ? event.evidence : 0
                }

                events.push(single_event)

            }
        })
    )

    events.sort(function (a, b) {
        return new Date(a.scheduled) - new Date(b.scheduled);
    });

    return {
        events: events,
        events_sources: eventsPreviewSources
    }

}

async function refactorEventDetailOdds(event, rules, onlyManager, treeStructure, producer, periods) {

    let events = []
    let eventsPreviewSources = []

    const options = {year: 'numeric', month: 'long', day: 'numeric'};

    if (event != null) {

        const rules_disabled = {
            manager: filter(rules.manager, {'type': 'disable', 'scope': 'event', 'source': event.id}),
            skin: filter(rules.skin, {'type': 'disable', 'scope': 'event', 'source': event.id})
        }

        eventsPreviewSources.push(event.id)

        var competitors = {}
        var result_odds = {};
        var description = ''

        switch (event.type) {
            case "match":

                competitors = {
                    home: {
                        ...await refactorElement(event.competitors[0], rules, onlyManager, event.competitors[0].id)
                    },
                    away: {
                        ...await refactorElement(event.competitors[1], rules, onlyManager, event.competitors[1].id)
                    },
                }

                description = competitors.home.name + ' - ' + competitors.away.name

                if (event.odds) {

                    var typeOdd = event.type

                    if(typeOdd != 'antepost'){

                        switch (event.sport_event_status._attributes.status) {
                            case 1:{
                                typeOdd = 'prematch'
                                break
                            }
                            case 2:{
                                typeOdd = 'live'
                                break
                            }
                            default:{
                                typeOdd = 'prematch'
                                break
                            }
                        }

                    }

                    result_odds = await rulesHandler.applyRulesToOdds(event.odds[0].markets, event.id, event.type, treeStructure, rules, onlyManager, producer, typeOdd,"detail")

                } else {

                    result_odds = {
                        id_market: null,
                        void: true
                    }

                }
                break;
        }

        if(typeOdd == 'live'){
            var currentPeriod = event.livescore.scoreboard.currentPeriod
            if(currentPeriod){
                var detail = find(periods, {'source':+currentPeriod})
                if(detail){
                    event.livescore.scoreboard.currentPeriod = detail.detail
                }
            }
        }


        var single_event = {
            id: event.id,
            source: event.id,
            // name: desc_season,
            scheduled: event.scheduled,
            day: new Date(event.scheduled).toLocaleDateString(rules.lang, options),
            time: new Date(event.scheduled).getTime(),
            // tournament_around: event.tournament_around,
            // odds: event.odds
            // status: status,
            competitors: competitors,
            odds: {...result_odds.oddsArray},
            type: event.type,
            description: description,
            count_odds: result_odds.count_odds,
            livescore: (typeOdd == 'live') ? event.livescore : {},
            quickbet: event.quickbet
        }

        events.push(single_event)

    }

    return {
        events: events,
        events_sources: eventsPreviewSources
    }

}

async function refactorMarkets(marketObj, lang) {

    let market_results = []

    var specifiers = orderBy(marketObj.specifiers, ['sort'])

    await Promise.all(specifiers.map(async (single_market) => {

            var desc_market = find(single_market.detail, {'lang': lang});

            if (!desc_market) {
                desc_market = find(single_market.detail, {'lang': 'en'});
            }

            if(single_market.specifiers != ''){
                single_market.specifiers
            }

            var outcomes = [];

            await Promise.all(single_market.outcomes.map(async (outcomeObj) => {
                    var outcome = await refactorOutcome(outcomeObj, lang);
                    outcomes.push(outcome)
                })
            )

            var singleMarket = {
                id: single_market.id,
                name: (single_market.specifiers != '') ? desc_market.text+' '+single_market.specifiers :desc_market.text,
                outcomes: outcomes,
                specifiers : (single_market.specifiers != '') ? single_market.specifiers : ''
            }

            market_results.push(singleMarket)

        })
    )

    return market_results
}

async function refactorGroupMarkets(groupMarketObj, lang) {

    let groupMarkets = []
    await Promise.all(groupMarketObj.map(async (single_group, index) => {

            var desc_group = find(single_group.name, {'lang': lang});
            if (!desc_group) {
                desc_group = find(single_group.name, {'lang': 'en'});
            }

            groupMarkets.push({name: desc_group.text, group_id: index})

        })
    )

    return groupMarkets
}

async function refactorOutcome(outcome, lang) {

    // var desc_outcome = find(outcome.name, {'lang': lang});
    // if (!desc_outcome) {
    //     desc_outcome = find(outcome.name, {'lang': 'en'});
    // }
    //
    // var name = desc_outcome.name.replace("{$competitor1}", "1");
    // name = name.replace("{$competitor2}", "2");
    // name = name.replace("draw", "X");
    // name = name.replace("pareggio", "X");
    // name = name.replace("empate", "X");
    // name = name.replace("Match nul", "X");
    // name = name.replace("平局", "X");


    return {id: outcome.id, name: outcome.name, sort: outcome.sort}

}

async function checkEventsPreview(preview, source) {

}

async function getStatusEventFromRule(source, rules) {

    const rules_disabled = {
        manager: (rules.manager.length > 0) ? find(rules.manager[0].detail, {'scope': 'event'}) : undefined,
        skin: (rules.skin.length > 0) ? find(rules.skin[0].detail, {'scope': 'event'}) : undefined
    }

    if (rules_disabled.manager == undefined && rules_disabled.skin == undefined) {
        return true
    } else {

        var status = true

        if (rules_disabled.manager) {
            status = !rules_disabled.manager.status
        }
        if (rules_disabled.skin) {
            status = !rules_disabled.skin.status
        }
        return status
    }

}

async function refactorNextEvents(dataAll, rules, producer, onlyManager, group = true) {

    return new Promise(async (resolve, reject) => {
        try {

            var data = find(dataAll, {'selected': true})
            var eventsObj = data.events
            var marketsObj = data.settings

            var promise = []
            forEachLodash(eventsObj, async (event) =>{
                promise.push(refactorSingleNextEvent(event, rules, producer, onlyManager, marketsObj))
            })

            var refactored = []
            await Promise.all(promise).then((result) =>{

                var clean_events = filter(result, function(o) { return o != false });

                if(group){

                    var groupedByTournament = groupBy(clean_events, (obj) =>{
                        return obj.tournament.id
                    })

                    forEachLodash(groupedByTournament, (tourn, index) =>{
                        var events = []
                        var events_sources = []

                        forEachLodash(tourn, (event) =>{
                            events.push(event.events[0])
                            events_sources.push(event.events_sources[0])
                        })

                        let object = {
                            category : tourn[0].category,
                            markets : tourn[0].markets,
                            markets_count : tourn[0].markets_count,
                            sport : tourn[0].sport,
                            tournament : tourn[0].tournament,
                            type: tourn[0].type,
                            events: events,
                            events_sources: events_sources,
                            events_count: events_sources.length
                        }

                        refactored.push(object)
                    })

                    resolve(refactored)

                }else{

                    resolve(clean_events)

                }
            })

        } catch (e) {

        }
    })

}
async function refactorNextEventsV2(dataAll,sport_id ,producer, onlyManager, group = true) {

    try {
        //todo add type match !!!

        var data = dataAll

        let sport = {
            id: data.sportId,
            name: data.sportName,
            sport_id: sport_id
        }

        var eventsObj = data.events
        var marketsObj = data.settings != null ? data.settings : null



        var promise = []
        for(const event of eventsObj){//todo in async with promise all
            promise.push(await refactorSingleNextEventV2(event, producer, onlyManager, marketsObj))
        }



        let eventRefactored = {
            sport : {
                ...sport
            },
            events: promise,
            headerSign: data.headerSign
        }
        return eventRefactored




    } catch (e) {
        console.log(e);
    }

}

async function refactorEventsDay(dataAll, rules, producer, onlyManager, group = true, headerSign = null) {

    return new Promise(async (resolve, reject) => {
        try {

            var data = find(dataAll, {'selected': true})

            var eventsObj = data.events
            var marketsObj = data.settings

            var promise = []
            forEachLodash(eventsObj, async (event) =>{

                promise.push(refactorSingleEventDay(event, rules, producer, onlyManager, marketsObj, headerSign))
            })

            var refactored = []
            await Promise.all(promise).then((result) =>{

                var clean_events = filter(result, function(o) { return o != false });

                if(group){

                    var groupedByTournament = groupBy(clean_events, (obj) =>{
                        return obj.tournament.id
                    })

                    forEachLodash(groupedByTournament, (tourn, index) =>{
                        var events = []
                        var events_sources = []

                        forEachLodash(tourn, (event) =>{
                            events.push(event.events[0])
                            events_sources.push(event.events_sources[0])
                        })

                        let object = {
                            category : tourn[0].category,
                            markets : tourn[0].markets,
                            markets_count : tourn[0].markets_count,
                            sport : tourn[0].sport,
                            tournament : tourn[0].tournament,
                            type: tourn[0].type,
                            events: events,
                            events_sources: events_sources,
                            events_count: events_sources.length
                        }

                        refactored.push(object)
                    })

                    resolve(refactored)

                }else{

                    resolve(clean_events)

                }
            })

        } catch (e) {

        }
    })

}

async function refactorEventsBestPlayed(dataAll, rules, producer, onlyManager, group = true, headerSign = null) {

    return new Promise(async (resolve, reject) => {
        try {

            var data = find(dataAll, {'selected': true})
            var eventsObj = data.events
            var marketsObj = data.settings

            // console.log('Events: ' + _.size(eventsObj))

            var promise = []
            forEachLodash(eventsObj, async (event) =>{
                promise.push(refactorSingleEventsBestPlayed(event, rules, producer, onlyManager, marketsObj, headerSign))
            })

            var refactored = []
            await Promise.all(promise).then((result) =>{

                var clean_events = filter(result, function(o) { return o != false });

                // console.log('Events: ' + _.size(clean_events))

                resolve(clean_events)

            })

        } catch (e) {

        }
    })

}
async function refactorEventsBestPlayedV2(dataAll, sportId,  sport_id , headerSign = null) { // todo rename and check best

    try {

        //todo add type match !!!
        var data = dataAll
        var eventsObj = data.events
        var marketsObj = data.settings

        let sport = {
            id: sportId,
            name: data.sportName, // todo
            sport_id: sport_id, // todo
        }

        //console.log("eventsObj", eventsObj)
        //console.log("sport", sport)




        // console.log('Events: ' + _.size(eventsObj))

        var promise = []
        for (const event of eventsObj){
            promise.push(await refactorSingleEventsBestPlayedV2(event, headerSign))
        }

        let refactoredEvent = {
            sport : {
                ...sport
            },
            events: promise,
            headerSign: headerSign
        }

        return refactoredEvent



    } catch (e) {

        console.log(e)
    }

}


async function refactorQuickBet(data, rules, producer, onlyManager, source) {

    var eventObj = data.events;
    var sportObj = data.events.sport;
    var categoryObj = data.events.category;
    var tournamentObj = data.events.tournament;

    var tree_structure = {
        sport: sportObj.id,
        category: categoryObj.id,
        tournament: tournamentObj.id
    }

    tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)

    var sport_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(sportObj, rules, onlyManager, sportObj.id);
        resolve(result)
    });

    var category_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.id);
        resolve(result)
    });

    var tournament_promise = new Promise(async (resolve, reject) => {
        let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.id);
        resolve(result)
    });

    var event_promise = new Promise(async (resolve, reject) => {
        let result = await refactorEventQuickBetOdds(eventObj, rules, onlyManager, tree_structure, producer);
        resolve(result)
    });


    const responsePromises = await Promise.all([
        sport_promise,
        category_promise,
        tournament_promise,
        event_promise
    ])


    return {
        sport: {
            ...responsePromises[0]
        },
        category: {
            ...responsePromises[1]
        },
        tournament: {
            ...responsePromises[2]
        },
        event: {
            ...responsePromises[3]
        },
        source: responsePromises[3].id

    }
}

async function getResult(result, team) {
    if (team == 'home') {
        var point = find(result, {'Position': "1"})
        return (point) ? +point.Value : 0
    } else if (team == 'away') {
        var point = find(result, {'Position': "2"})
        return (point) ? +point.Value : 0
    } else {
        return 0
    }
}

async function refactorEventQuickBetOdds(event, rules, onlyManager, treeStructure, producer) {

    const options = {year: 'numeric', month: 'long', day: 'numeric'};
    var single_event = {}

    if (event != null) {
        //console.log(rules)
        const rules_disabled = {
            manager: filter(rules.manager, {'type': 'disable', 'scope': 'event', 'source': _.toString(event.id)}),
            skin: filter(rules.skin, {'type': 'disable', 'scope': 'event', 'source': _.toString(event.id)})
        }

        var status
        if (rules_disabled.manager.length > 0 || rules_disabled.skin.length > 0) {
            //         console.log(event.id.toString(), rules_disabled)
            status = await getStatusEventFromRule(event.id.toString(), rules_disabled)
            //console.log("status",status)
            //status= true

        }else{
            status =true
        }
        var competitors = {}
        var result_odds = {};
        var description = ''

        switch (event.type) {
            case "match":

                competitors = {
                    home: {
                        ...await refactorElement(event.competitors[0], rules, onlyManager, event.competitors[0].id)
                    },
                    away: {
                        ...await refactorElement(event.competitors[1], rules, onlyManager, event.competitors[1].id)
                    },
                }

                description = competitors.home.name + ' - ' + competitors.away.name

                if (event.odds) {

                    var typeOdd = event.type

                    if(typeOdd != 'antepost'){

                        switch (event.sport_event_status._attributes.status) {
                            case 1:{
                                typeOdd = 'prematch'
                                break
                            }
                            case 2:{
                                typeOdd = 'live'
                                break
                            }
                            default:{
                                typeOdd = 'prematch'
                                break
                            }
                        }

                    }

                    result_odds = await rulesHandler.applyRulesToOdds(event.odds, event.id, event.type, treeStructure, rules, onlyManager, producer, typeOdd,"detail")

                } else {

                    result_odds = {
                        id_market: null,
                        void: true
                    }

                }
                break;
        }

        single_event = {
            id: event.id,
            source: event.id,
            // name: desc_season,
            scheduled: event.scheduled,
            day: new Date(event.scheduled).toLocaleDateString(rules.lang, options),
            time: new Date(event.scheduled).getTime(),
            // tournament_around: event.tournament_around,
            // odds: event.odds
            status: status,
            competitors: competitors,
            odds: {...result_odds.oddsArray},
            type: event.type,
            description: description,
            count_odds: result_odds.count_odds,
            livescore: (typeOdd == 'live') ? event.livescore : {},
            quickbet: event.quickbet
        }

    }
    return single_event
}


async function refactorEventDetailV3(eventData) {

    let headerSign = eventData.headerSign != null ? eventData.headerSign : null;

    return {
        sport: {
            ...{
                id: eventData.event.sportId,
                name: eventData.event.sportName
            }
        },
        category: {
            ...{
                id: eventData.event.categoryId,
                name: eventData.event.categoryName,
            }
        },
        tournament: {
            ...{
                id: eventData.event.tournamentId,
                name: eventData.event.tournamentName,
            }
        },
        event: eventData.event,
        source: eventData.event.id,
        type: 'prematch',
        headerSign: headerSign,
        groupMarkets: eventData.marketsGroups
    }




}

async function refactorEventAntepostDetailV3(eventData) {

    // Ordiniamo gli eventi associati per data o nome per sicurezza (opzionale ma consigliato)
    let siblings = eventData.event.associatedEvents || [];
    siblings.sort((a, b) => new Date(a.scheduledDate) - new Date(b.scheduledDate));

    return {
        sport: {
            id: eventData.event.sport.id,
            name: eventData.event.sport.name
        },
        category: {
            id: eventData.event.category.id,
            name: eventData.event.category.name
        },
        tournament: {
            id: eventData.event.tournament.id,
            name: eventData.event.tournament.name
        },
        event: eventData.event,
        source: eventData.event.id,
        type: 'antepost',

        // --- NUOVO CAMPO ---
        // Portiamo l'array nel frontend
        associatedEvents: siblings,

        raceTitle: await getRaceTitle(eventData.event.FixtureExtraData),
        raceNumber: await getRaceNumber(eventData.event.FixtureExtraData)
    }
}


const getRaceTitle = async (fixtureExtraData) => {

    const raceTitle = fixtureExtraData.find(el => {
        return el.Name === "RaceTitle"
    })

    return raceTitle
}

const getRaceNumber = async (fixtureExtraData) => {

    const raceNumber = fixtureExtraData.find(el => {
        return el.Name === "RaceNumber"
    })

    return raceNumber
}

export default {
    refactorNextEvents,
    refactorNextEventsV2,
    refactorEventsDay,
    refactorEventsBestPlayed,
    refactorEventsBestPlayedV2,
    refactorLive,
    refactorSingleLive,
    refactorPreview,
    refactorPreviewV2,
    refactorPreviewAntepost,
    refactorDetail,
    refactorOddsDetail,
    refactorQuickBet,
    getResult,
    refactorEventDetailV3,
    refactorEventAntepostDetailV3,
    refactorLivePreviewV3,
    refactorEventsBestPlayedV3
}

// TODO am refactoring this module inside module eventsOddsHandlerV3.. when i am ready i have to delete this file
